import { Injectable } from '@angular/core';

function getFileName(mimeType: string) {
  return `d${(+new Date()).toString(16)}${mimeType === 'application/pdf' ? '.pdf' : ''}`;
}

@Injectable()
export class NativeWindowService {
  constructor() {}

  get window(): Window {
    return window;
  }

  openFile(file: Blob, fileName?: string, tab?: any): void {
    if (!file) {
      throw new Error('Invalid operation. File is missing.');
    }

    if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
      if (!fileName || fileName.trim() === '') {
        fileName = getFileName(file.type);
      }
      (window.navigator as any).msSaveOrOpenBlob(file, fileName);
    } else {
      const url = URL.createObjectURL(file);
      if (!tab) {
        tab = this.openTab();
      }
      tab.location.assign(url);
    }
  }

  newTab(): Window {
    return window.open();
  }

  navigate(window: Window, url: string) {
    if (window) window.location.assign(url);
  }

  openTab(url?: string) {
    const newTab = this.newTab();
    if (!url) return newTab;

    this.navigate(newTab, url);
  }

  saveWithDecodedFileName(file: File) {
    let result = new File([file], decodeURIComponent(file.name.replace(/\+/g, ' ')));
    this.save(result);
  }

  save(file: File) {
    if (!file) {
      return;
    }

    if (window.document) {
      const element = window.document.createElement('a') as HTMLAnchorElement;
      if (element) {
        window.document.body.appendChild(element);
        element.download = file.name;
        element.href = URL.createObjectURL(file);
        element.click();
        window.document.body.removeChild(element);
        URL.revokeObjectURL(element.href);
      }
    }
  }
}
